import { Select, Spin } from 'antd';
import { Field } from 'formik-antd';
import { ChangeEvent } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';

type ValidateFunction = (value: any) => string | Promise<any> | undefined;
interface LocationInputProps {
    placeholder?: string;
    name: string;
    validate?: ValidateFunction;
    fast?: boolean;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onSelect?: (address: string, placeID: string) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    specificAddress?: boolean;
}

const LocationInput = ({ placeholder, name, validate, fast, onChange: $onChange, onBlur: $onBlur, onSelect: $onSelect, specificAddress = true, ...props }: LocationInputProps) => (
    <Field fast={fast} name={name} validate={validate}>
        {({ field: { value, onChange, onBlur } }) => {
            if (!window.google) return null; // Check if Google Maps has loaded

            return (
                <PlacesAutocomplete
                    onChange={(value) => {
                        const event = { target: { value, name } };
                        onChange(event);
                        $onChange && $onChange(event as React.ChangeEvent<HTMLInputElement>);
                    }}
                    value={value}
                    onSelect={(address: string, placeID: string) => {
                        const event = { target: { value: address, name } };
                        onChange(event);
                        $onSelect && $onSelect(address, placeID);
                    }}
                    {...props}
                    debounce={300}
                    searchOptions={{
                        types: specificAddress ? ['route', 'locality'] : undefined,
                        location: new google.maps.LatLng(54.165, -4.417),
                        radius: specificAddress ? 2000 : 55000,
                        componentRestrictions: { country: 'gb' },
                    }}
                >
                    {({ getInputProps, getSuggestionItemProps, loading, suggestions }) => {
                        const { onChange, ...inputProps } = getInputProps({
                            allowClear: true,
                            filterOption: false,
                            placeholder,
                            showSearch: true,
                            notFoundContent: loading ? <Spin size="small" /> : 'Sorry, no locations were found',
                            onClear: () => onChange({ target: { value: '' } }),
                            onSearch: (value: string) => onChange({ target: { value } }),
                            onSelect: (value: string) => {
                                const activeSuggestion = suggestions.find((suggestion) => suggestion.placeId === value);
                                if (activeSuggestion) {
                                    const { onClick } = getSuggestionItemProps(activeSuggestion);
                                    onClick({
                                        ...new MouseEvent('click'),
                                        persist: () => null,
                                    } as unknown as React.MouseEvent);
                                }
                            },
                            name,
                        });

                        // 4. Optional: Filter suggestions client-side to be more precise
                        const filteredSuggestions = specificAddress ? suggestions.filter((suggestion) => !suggestion.types.includes('country') && !suggestion.types.includes('political')) : suggestions;
                        console.log({ filteredSuggestions, suggestions, specificAddress });
                        return (
                            <Select
                                {...inputProps}
                                onBlur={(event) => {
                                    onBlur('location')(event);
                                    $onBlur && $onBlur(event as React.FocusEvent<HTMLInputElement>);
                                }}
                            >
                                {filteredSuggestions.map((suggestion) => (
                                    <Select.Option {...getSuggestionItemProps(suggestion)} key={suggestion.placeId}>
                                        {suggestion.description}
                                    </Select.Option>
                                ))}
                            </Select>
                        );
                    }}
                </PlacesAutocomplete>
            );
        }}
    </Field>
);

export { LocationInput };
